import styles from './Navigation.module.scss'
import { Icon } from 'semantic-ui-react'
import { Link } from 'react-router'
import InitialPropsContext from '../InitialPropsContext/InitialPropsContext'
import { useContext } from 'react'
import { Responsive } from '../Responsive/Responsive'
import { env } from '../../config/env'

interface NavigationProps {
  accountName: string
}

export const Navigation = ({ accountName }: NavigationProps): JSX.Element => {
  const { customContent } = useContext(InitialPropsContext)

  return (
    <nav className={styles.nav}>
      <div className={styles.navWrapper}>
        <Link to="/" className={styles.accountInfo}>
          {!!customContent && !!customContent.logo ? (
            <img
              className={styles.logo}
              src={customContent.logo}
              alt="120 Water Audit Logo"
            />
          ) : (
            <img
              className={styles.logo}
              src="/static/logomark-color.png"
              alt="120 Water Audit Logo"
            />
          )}
          <span>{accountName}</span>
        </Link>
        <a className={styles.adminLink} href={env.adminLoginUrl}>
          <Responsive platform="desktop">
            <span>Admin Login </span>
            <Icon name="triangle right" />
          </Responsive>
          <Responsive platform="mobile">
            <Icon name="bars" />
          </Responsive>
        </a>
      </div>
    </nav>
  )
}
